import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile/profile.component';
import { ConfigRegistroComponent } from './config-registro/config-registro.component';


const routes: Routes = [
  {
    path: 'profile/:id',
    component: ProfileComponent,
    data: {
      title: "Perfil",
      breadcrumb: "Perfil"
    }
  },
  {
    path: 'configuracion',
    component: ConfigRegistroComponent,
    data: {
      title: "Configuración",
      breadcrumb: "Configuración"
    }
  },
  {
    path: 'configuracion/:id',
    component: ConfigRegistroComponent,
    data: {
      title: "Editar Configuración",
      breadcrumb: "Editar Configuración"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingRoutingModule { }
